import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AppShell from '../../../components/layout/AppShell';
import AdminDashboardHeader from '../../../components/admin/AdminDashboardHeader';
import { apiRequest } from '../../../api/client';
import './dashboard.css';

type DashboardWorkOrder = {
    _id: string;
    title?: string;
    client?: {
        name?: string;
        address?: string;
    };
    schedule?: {
        startTime?: string;
    };
};

function AdminDash(): React.JSX.Element {
    const navigate = useNavigate();
    const [activeSiteAddress, setActiveSiteAddress] = useState<string>('');
    const [workOrders, setWorkOrders] = useState<DashboardWorkOrder[]>([]);

    useEffect(() => {
        apiRequest<{ data: DashboardWorkOrder[] }>('/api/work-orders')
            .then((data) => {
                const address = data.data?.[0]?.client?.address || '';
                setActiveSiteAddress(address);
                setWorkOrders(data.data || []);
            })
            .catch(() => {
                setActiveSiteAddress('');
                setWorkOrders([]);
            });
    }, []);
    return (
        <AppShell>
            <div className="dashboard-page">
                <AdminDashboardHeader
                    onCreateWorkOrder={() => navigate('/admin/work-orders')}
                    onViewQuotes={() => navigate('/admin/quotes')}
                    onCreateInvoice={() => navigate('/admin/invoices')}
                    showActions={false}
                />

            <section
                className="dash-card"
                style={{
                    marginBottom: '28px',
                    display: 'flex',
                    flexWrap: 'wrap',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: '16px'
                }}
            >
                <div>
                    <p className="dash-label">Client directory</p>
                    <p style={{ margin: '6px 0 0', color: 'var(--dash-muted)', fontSize: '0.95rem', maxWidth: '520px' }}>
                        Add and search clients so they appear when you build quotes and invoices.
                    </p>
                </div>
                <button
                    type="button"
                    className="dash-btn dash-btn-primary"
                    onClick={() => navigate('/admin/clients')}
                >
                    Open clients
                </button>
            </section>

            <section className="dash-stats">
                <article className="dash-card">
                    <p className="dash-label">Active Sites</p>
                    {activeSiteAddress ? <h2>{activeSiteAddress}</h2> : null}
                </article>
                <article className="dash-card">
                    <p className="dash-label">Open Tickets</p>
                </article>
                <article className="dash-card">
                    <p className="dash-label">Inspections Due</p>
                </article>
                <article className="dash-card">
                    <p className="dash-label">Systems Online</p>
                </article>
            </section>

            <section className="dash-grid">
                <article className="dash-card dash-card-wide">
                    <div className="dash-card-header">
                        <h3>Today&apos;s Route</h3>
                    </div>
                    <ul className="dash-list">
                        {workOrders.map((order) => (
                            <li key={order._id}>
                                <div>
                                    <p className="dash-list-title">{order.client?.name || order.title || 'Assigned Site'}</p>
                                    <p className="dash-list-meta">{order.client?.address || '—'}</p>
                                </div>
                                {order.schedule?.startTime ? (
                                    <span className="dash-time">{order.schedule.startTime}</span>
                                ) : null}
                            </li>
                        ))}
                    </ul>
                </article>

                <article className="dash-card">
                    <div className="dash-card-header">
                        <h3>System Health</h3>
                    </div>
                </article>

                <article className="dash-card">
                    <div className="dash-card-header">
                        <h3>Recent Incidents</h3>
                    </div>
                </article>

                <article className="dash-card">
                    <div className="dash-card-header">
                        <h3>Compliance Snapshot</h3>
                    </div>
                </article>
            </section>
            </div>
        </AppShell>
    );
}

export default AdminDash;
